import type { ClassValue } from 'clsx'

import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

// "K. Md. Rafi" -> "KR", "Sukesh Dash" -> "SD"
export function getInitials(name: string): string {
    const parts = name
        .split(/\s+/)
        .map(part => part.replace(/[^A-Za-zÀ-ɏ]/g, ''))
        .filter(Boolean)

    if (parts.length === 0) return ''
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()

    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
}
